var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productLabel === null)?_c('em',[_vm._v("Loading Referral Reactor Plan...")]):_c('strong',[_vm._v(_vm._s(_vm.productLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }